import { GuidedTourTooltip } from './GuidedTourTooltip';

const JoyrideStyles: { buttonClose: { display: string }; options: { zIndex: number } } = {
  options: {
    zIndex: 1000,
  },
  buttonClose: {
    display: 'none',
  },
};

const JoyrideFloaterProps: any = {
  disableAnimation: true, // because animation flickering when component mount
};

export const defaultGuidedTourProps = {
  tooltipComponent: GuidedTourTooltip,
  styles: JoyrideStyles,
  floaterProps: JoyrideFloaterProps,
  disableOverlayClose: true,
  continuous: true,
  disableCloseOnEsc: true,
  showSkipButton: true,
  spotlightPadding: 0,
};
